import { Component, ComponentRef, ComponentFactoryResolver, ApplicationRef, ViewContainerRef, Injectable, Input, NgModule, ElementRef, Compiler, AfterViewInit, OnDestroy } from '@angular/core';
import { CommonModule } from "@angular/common";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs/Rx';
import * as _ from 'lodash';

import { TestTakerActions } from '../../../store/actions';
import * as fromRoot from '../../../store/reducers';

export interface IMyModalButton {
    label: string;
    style: string;
}

@Injectable()
export class MyModal {

    private vRef: ViewContainerRef;

    constructor(
        private componentFactoryResolver: ComponentFactoryResolver,
        private app: ApplicationRef,
        private domSanitizer: DomSanitizer,
        private compiler: Compiler
    ) {
    }

    setRootViewContainerRef(vRef: ViewContainerRef) {
        this.vRef = vRef;
    }

    showRegularDlg(title: string, message: string, buttons: IMyModalButton[] = [{ label: "Close", style: "btn-default" }]): Promise<any> {
        return this.show(title, message, "regular", buttons, null);
    }

    showTimesUpDlg(timesUpCallback: Function): Promise<any> {
        return this.show("Time is up", "", "times-up", [{ label: "Next", style: "btn-default btn-times-up-next" }], timesUpCallback);
    }

    private show(title: string, message: string, mode: string, buttons: IMyModalButton[], timesUpCallback: Function): Promise<any> {
        return new Promise((resolve, reject) => {
            const type = this.createNewComponent(title, mode, this.domSanitizer.bypassSecurityTrustHtml(message), buttons);
            const module = this.createComponentModule(type);

            this.compiler
                .compileModuleAndAllComponentsAsync(module)
                .then((moduleWithFactories) => {
                    const factory = _.find(moduleWithFactories.componentFactories, { componentType: type });
                    const componentRef = this.vRef.createComponent(factory, 0);
                    componentRef.instance.cref = componentRef;
                    componentRef.instance.result = resolve;
                    componentRef.instance.timesUpCallback = timesUpCallback;
                });
        });
    }

    private createComponentModule(componentType: any) {
        @NgModule({
            imports: [
                CommonModule
            ],
            declarations: [componentType],
        })
        class MyModalComponentModule {
        }
        return MyModalComponentModule;
    }

    private createNewComponent(title: string, mode: string, message: SafeHtml, buttons: IMyModalButton[]) {
        @Component({
            selector: 'modal',
            template: require('./my-modal.component.html')
        })
        class MyModalComponent implements OnDestroy, AfterViewInit {
            @Input() cref: ComponentRef<any>;
            @Input() result: any;
            @Input() timesUpCallback: Function;
            private title: string = title;
            private mode: string = mode;
            private message: SafeHtml = message;
            private buttons: IMyModalButton[] = buttons;
            private timesUpCountDown: number = 5;
            private buttonClickSubscription: Subscription;
            private timesUpSubscription: Subscription;

            constructor(
                private store: Store<fromRoot.State>,
                private elementRef: ElementRef
            ) {
            }

            ngAfterViewInit() {
                const clickObservables = [];
                const elems = (this.elementRef.nativeElement as HTMLElement).getElementsByClassName("btn-modal");
                for (let i = 0; i < elems.length; i++) {
                    clickObservables.push(Observable.fromEvent(elems[i], "click"));
                }
                this.buttonClickSubscription = Observable.merge(...clickObservables)
                    .take(1)
                    .do((mouseEvent: MouseEvent) => {
                        const btn = (mouseEvent.target) as HTMLElement;
                        this.onClick(btn.innerText);
                    })
                    .delay(600)
                    .repeat()
                    .subscribe();

                if (this.mode == "times-up") {
                    this.initTimesUpMode();
                }
            }

            ngOnDestroy() {
                if (this.buttonClickSubscription) {
                    this.buttonClickSubscription.unsubscribe();
                }
            }

            private onClick(label: string) {
                this.cref.destroy();
                this.result(label);
                if (this.mode == "times-up" && this.timesUpSubscription != null) {
                    this.timesUpSubscription.unsubscribe();
                    this.timesUpCallback();
                }
            }

            private initTimesUpMode() {
                const btns = (this.elementRef.nativeElement as HTMLElement).getElementsByClassName("btn-times-up-next");
                let btnNext: HTMLButtonElement = null;
                if (btns.length == 1) {
                    btnNext = btns[0] as HTMLButtonElement;
                }

                this.timesUpSubscription = Observable.interval(1000)
                    .take(5)
                    .subscribe(
                    counter => {
                        this.timesUpCountDown -= 1;
                        btnNext.disabled = this.timesUpCountDown <= 2;
                    },
                    null,
                    () => {
                        this.timesUpCallback();
                        this.cref.destroy();
                    }
                    );
            }
        }
        return MyModalComponent;
    }

}




// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/common/my-modal/my-modal.component.ts